import React, { useState, useEffect, useRef } from 'react';
import './OfferBanner.css';

const offers = [
  { id: 1, icon: 'fa-gift', text: 'Get up to 10% OFF on Prepaid Orders — Limited Time Offer!', prepaidOnly: true },
  { id: 2, icon: 'fa-gift', text: 'Get up to 10% OFF on Prepaid Orders — Limited Time Offer!', prepaidOnly: true },
  { id: 3, icon: 'fa-gift', text: 'Get up to 10% OFF on Prepaid Orders — Limited Time Offer!', prepaidOnly: true },
  { id: 4, icon: 'fa-gift', text: 'Get up to 10% OFF on Prepaid Orders — Limited Time Offer!', prepaidOnly: true },
    { id: 5, icon: 'fa-gift', text: 'Get up to 10% OFF on Prepaid Orders — Limited Time Offer!', prepaidOnly: true },
];

const OfferBanner = ({ paymentMethod = 'prepaid' }) => {
  const [visible, setVisible] = useState(true);
  const [current, setCurrent] = useState(0);
  const [animating, setAnimating] = useState(false);
  const intervalRef = useRef(null);

  const filteredOffers = offers.filter(o => !o.prepaidOnly || paymentMethod === 'prepaid');

  const goTo = (index) => {
    setAnimating(true);
    setTimeout(() => {
      setCurrent(index);
      setAnimating(false);
    }, 300);
  };

  const next = () => goTo((current + 1) % filteredOffers.length);
  const prev = () => goTo((current - 1 + filteredOffers.length) % filteredOffers.length);

  useEffect(() => {
    if (!visible || filteredOffers.length <= 1) return;
    intervalRef.current = setInterval(next, 3500);
    return () => clearInterval(intervalRef.current);
  }, [visible, current, filteredOffers.length]);

  if (!visible || filteredOffers.length === 0) return null;

  const offer = filteredOffers[current];

  return (
    <div className="offer-banner">
      <div className="offer-banner__ticker">
        <button className="offer-banner__nav" onClick={prev} aria-label="Previous offer">
          <i className="fa fa-chevron-left"></i>
        </button>

        <div className={`offer-banner__content ${animating ? 'offer-banner__content--exit' : 'offer-banner__content--enter'}`}>
          <i className={`fa ${offer.icon} offer-banner__icon`}></i>
          <span className="offer-banner__text">{offer.text}</span>
          {offer.prepaidOnly && (
            <span className="offer-banner__tag">
              <i className="fa fa-credit-card"></i> Prepaid Only
            </span>
          )}
        </div>

        <button className="offer-banner__nav" onClick={next} aria-label="Next offer">
          <i className="fa fa-chevron-right"></i>
        </button>
      </div>

    </div>
  );
};

export default OfferBanner;